import React from 'react'

import Card from '../../../../atoms/card/Card'
import DisplayField from '../../../../atoms/form/display-field/DisplayField'
import InlineGroup from '../../../../atoms/inlinegroup/InlineGroup'
import Clickable from '../../../../atoms/clickable/Clickable'
import Icon from '../../../../atoms/icon/Icon'
import { getLabelFromValue as getEconomyLabel } from './EconomyDropdown'
import { getLabelFromValue as getTermFundingLabel } from './TermFundingDropdown'
import { getLabelFromValue as getCapitalManagementLabel } from './CapitalManagementDropdown'


interface Props {
  data: API.SimulationResponse['moduleSetup']
  onClickEdit?: () => void
}

const Display: React.FC<Props> = ({ data, onClickEdit }) => {
  return data ? (
    <Card wide>
      <InlineGroup verticalCenter>
        <h4>Economy and Other Settings</h4>
        {
          onClickEdit ? <Clickable
            data-test={'edit-simulation-module-step'}
            onClick={onClickEdit}>
            <Icon
              type='edit'
              tip={{
                content: 'Edit Module',
                id: 'edit-module'
              }}
            />
          </Clickable>
            : null
        }
      </InlineGroup>
      <DisplayField label='Economy' value={getEconomyLabel(data.economy)} />
      <DisplayField label='Term Funding' value={getTermFundingLabel(data.termFunding)} />
      <DisplayField label='Capital Management' value={getCapitalManagementLabel(data.capitalManagement)} />
      <DisplayField label='Operating Costs' value={data.operatingCostsEnabled ? 'Enabled' : 'Disabled'} />
    </Card>
  ) : null
}

export default Display
